<template>
 
    <div class="WordSection1" >
        <p class="MsoNormal" style="text-align:center">
      <span lang="EN-US" style='font-size:18.0pt;font-family:"Arial",sans-serif'
        >GF-6 Satellite</span
      >
    </p>
      <hr class="divider" />
      <p class="MsoNormal" align="center" style="text-align:center">
        <span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"Arial",sans-serif;mso-no-proof:yes'
          ><!--[if gte vml 1
            ]><v:shapetype
              id="_x0000_t75"
              coordsize="21600,21600"
              o:spt="75"
              o:preferrelative="t"
              path="m@4@5l@4@11@9@11@9@5xe"
              filled="f"
              stroked="f"
            >
              <v:stroke joinstyle="miter" />
              <v:formulas>
                <v:f eqn="if lineDrawn pixelLineWidth 0" />
                <v:f eqn="sum @0 1 0" />
                <v:f eqn="sum 0 0 @1" />
                <v:f eqn="prod @2 1 2" />
                <v:f eqn="prod @3 21600 pixelWidth" />
                <v:f eqn="prod @3 21600 pixelHeight" />
                <v:f eqn="sum @0 0 1" />
                <v:f eqn="prod @6 1 2" />
                <v:f eqn="prod @7 21600 pixelWidth" />
                <v:f eqn="sum @8 21600 0" />
                <v:f eqn="prod @7 21600 pixelHeight" />
                <v:f eqn="sum @10 21600 0" />
              </v:formulas>
              <v:path
                o:extrusionok="f"
                gradientshapeok="t"
                o:connecttype="rect"
              />
              <o:lock v:ext="edit" aspectratio="t" /> </v:shapetype
            ><v:shape
              id="图片_x0020_1"
              o:spid="_x0000_i1025"
              type="#_x0000_t75"
              alt="GF6"
              style="width:331pt;height:198pt;visibility:visible;mso-wrap-style:square"
            >
              <v:fill o:detectmouseclick="t" />
              <v:imagedata
                src="GF6.files/image001.png"
                o:title="GF6"
              /> </v:shape><!
          [endif]--><img
            width="441"
            height="264"
            src="../../assets/gf6sat.png"
            alt="GF6"
            v:shapes="图片_x0020_1"/></span

        ><span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"Arial",sans-serif'
          ><o:p></o:p
        ></span>
      </p>

      <p
        class="MsoNormal"
        align="left"
        style="text-align:left;text-indent:21.0pt;
mso-char-indent-count:2.0;mso-pagination:widow-orphan"
      >
        <span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
0pt;mso-bidi-language:AR'
          >GF-6 satellite was successfully launched on June 2, 2018. It is
          mainly used in fine agricultural observation, forestry resource survey
          and other industries. The Ministry of Natural Resources is its main
          user. The satellite has realized the domestic manufacture of 8-band
          CMOS detector. For the first time in China, &quot;red-edge&quot; band
          which can effectively reflect the spectral characteristics of crops
          has been added, which greatly improves the monitoring ability of
          agriculture, forestry and grassland resources.<o:p></o:p
        ></span>
      </p>

      <p
        class="MsoNormal"
        align="left"
        style="text-align:left;text-indent:21.0pt;
mso-char-indent-count:2.0;mso-pagination:widow-orphan"
      >
        <span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
0pt;mso-bidi-language:AR'
          >GF-6 satellite is equipped with 2-meter panchromatic/8-meter
          multi-spectral camera, 16-meter multi-spectral medium resolution
          wide-swath camera, 2-meter panchromatic/8-meter multi-spectral camera
          with 90 km swath width and 16-meter multi-spectral camera with 800 km
          swath width. After the networking operation of the GF-6 and GF-1
          satellites, the time frequency of remote sensing data acquisition will
          be improved from 4 days to 2 days, which will provide data support for
          agricultural and rural development, ecological civilization and other
          major needs. <o:p></o:p
        ></span>
      </p>

      <p class="MsoNormal" style="mso-pagination:widow-orphan">
        <span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
0pt;mso-bidi-language:AR'
          ><o:p>&nbsp;</o:p></span
        >
      </p>

      <span
        lang="EN-US"
        style='font-size:10.5pt;font-family:"Arial",sans-serif;
mso-fareast-font-family:宋体;mso-font-kerning:0pt;mso-ansi-language:EN-US;
mso-fareast-language:ZH-CN;mso-bidi-language:AR'
        ><br clear="all" style="page-break-before:always" />
      </span>

      <p class="MsoNormal" style="mso-pagination:widow-orphan">
        <b
          ><span
            lang="EN-US"
            style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
0pt;mso-bidi-language:AR'
            >Sensor technical parameters</span
          ></b
        >
      </p>

      <div align="center">
        <table
          class="MsoTableGrid"
          border="1"
          cellspacing="0"
          cellpadding="0"
          style="border-collapse:collapse;border:none;width:100%"
        >
          <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
            <td
              width="189"
              style="width:141.7pt;border:solid windowtext 1.0pt;mso-border-alt:
  solid windowtext .5pt;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <b
                  ><span
                    lang="EN-US"
                    style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                    >Parameter<o:p></o:p></span
                ></b>
              </p>
            </td>
            <td
              width="378"
              colspan="2"
              style="width:283.4pt;border:solid windowtext 1.0pt;
  border-left:none;mso-border-left-alt:solid windowtext .5pt;mso-border-alt:
  solid windowtext .5pt;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <b
                  ><span
                    lang="EN-US"
                    style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                    >High-resolution camera</span
                  ></b
                ><b
                  ><span
                    lang="EN-US"
                    style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                    ><o:p></o:p></span
                ></b>
              </p>
            </td>
            <td
              width="378"
              colspan="3"
              style="width:283.4pt;border:solid windowtext 1.0pt;
  border-left:none;mso-border-left-alt:solid windowtext .5pt;mso-border-alt:
  solid windowtext .5pt;background:#C7DAF1;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <b
                  ><span
                    lang="EN-US"
                    style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                    >Wide-swath camera</span
                  ></b
                ><b
                  ><span
                    lang="EN-US"
                    style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                    ><o:p></o:p></span
                ></b>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:1">
            <td
              width="189"
              rowspan="9"
              style="width:141.7pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Spectral band</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span class="SpellE"
                  ><span
                    lang="EN-US"
                    style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                    >anchromatic</span
                  ></span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.45</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.90 <span class="SpellE">μm</span></span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Panchromatic</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >——</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:2">
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Blue</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.45</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.52 <span class="SpellE">μm</span></span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >B1</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.45</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.52 <span class="SpellE">μm</span> </span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:3">
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Green</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.52</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.60 <span class="SpellE">μm</span></span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >B2</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.52</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.59 <span class="SpellE">μm</span> </span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:4">
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Red</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.63</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.69 <span class="SpellE">μm</span></span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >B3</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.63</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.69 <span class="SpellE">μm</span> </span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:5">
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Near-infrared</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.76</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.90 <span class="SpellE">μm</span></span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >B4</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.77</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.89 <span class="SpellE">μm</span> </span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:6;height:16.9pt">
            <td
              width="378"
              colspan="2"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt;
  height:16.9pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >——</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt;
  height:16.9pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >B5</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt;
  height:16.9pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.69</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.73 <span class="SpellE">μm</span> (</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Arial;
  mso-hansi-font-family:Arial;mso-bidi-font-family:Arial;color:black;
  mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:AR"
                  >红边</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >I) </span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:7">
            <td
              width="378"
              colspan="2"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >——</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >B6</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.73</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.77 <span class="SpellE">μm</span> (</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Arial;
  mso-hansi-font-family:Arial;mso-bidi-font-family:Arial;color:black;
  mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:AR"
                  >红边</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >II) </span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:8">
            <td
              width="378"
              colspan="2"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >——</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >B7</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.40</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.45 <span class="SpellE">μm</span> </span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:9">
            <td
              width="378"
              colspan="2"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >——</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >B8</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >0.59</span
                ><span
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;
  mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;mso-bidi-font-family:
  Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR"
                  >～</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR'
                  >0.63 <span class="SpellE">μm</span> </span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:10">
            <td
              width="189"
              rowspan="2"
              style="width:141.7pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >GSD</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Panchromatic</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >2 m</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Panchromatic</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >——</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:11">
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Multispectral</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >8 m</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="129"
              style="width:97.0pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Multispectral</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="249"
              colspan="2"
              style="width:186.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≤16m (without side swing)</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:12">
            <td
              width="189"
              style="width:141.7pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Swath width</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="378"
              colspan="2"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥90km</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="378"
              colspan="3"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥800km</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:13">
            <td
              width="189"
              rowspan="4"
              style="width:141.7pt;border:solid windowtext 1.0pt;
  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >SNR</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              rowspan="2"
              style="width:141.7pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Panchromatic</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥47dB(solar elevation angle 70°</span
                ><span
                  style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR"
                  >，</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  >surface reflectance 0.65)</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              colspan="2"
              rowspan="2"
              style="width:141.7pt;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Panchromatic</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >——</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:14">
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥28dB(solar elevation angle 30°</span
                ><span
                  style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR"
                  >，</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  >surface reflectance 0.03)</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >——</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:15">
            <td
              width="189"
              rowspan="2"
              style="width:141.7pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Multi-spectral</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥46dB(solar elevation angle 70°</span
                ><span
                  style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR"
                  >，</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  >surface reflectance 0.65)</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              colspan="2"
              rowspan="2"
              style="width:141.7pt;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Multi-spectral</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥46dB(solar elevation angle 70°</span
                ><span
                  style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR"
                  >，</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  >surface reflectance 0.65)</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:16">
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥20dB(solar elevation angle 30°</span
                ><span
                  style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR"
                  >，</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  >surface reflectance 0.03)</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="189"
              style="width:141.7pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥20dB(solar elevation angle 30°</span
                ><span
                  style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-ascii-font-family:Arial;mso-hansi-font-family:Arial;
  mso-bidi-font-family:Arial;color:black;mso-color-alt:windowtext;mso-font-kerning:
  0pt;mso-bidi-language:AR"
                  >，</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:
  10.5pt;font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  >surface reflectance 0.03)</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:17">
            <td
              width="189"
              style="width:141.7pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Absolute radiation <br />
                  calibration</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="378"
              colspan="2"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥7%</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="378"
              colspan="3"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥7%</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>
          <tr style="mso-yfti-irow:18;mso-yfti-lastrow:yes">
            <td
              width="189"
              style="width:141.7pt;border:solid windowtext 1.0pt;border-top:
  none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
  background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >Relative radiation <br />
                  calibration</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;
  font-family:"Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="378"
              colspan="2"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥3%</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
            <td
              width="378"
              colspan="3"
              style="width:283.4pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;
  mso-border-alt:solid windowtext .5pt;background:white;padding:0cm 5.4pt 0cm 5.4pt"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;mso-pagination:widow-orphan"
              >
                <span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:"Arial",sans-serif;
  color:black;mso-color-alt:windowtext;mso-font-kerning:0pt;mso-bidi-language:
  AR'
                  >≥3%</span
                ><span
                  lang="EN-US"
                  style='mso-bidi-font-size:10.5pt;font-family:
  "Arial",sans-serif;mso-font-kerning:0pt;mso-bidi-language:AR'
                  ><o:p></o:p
                ></span>
              </p>
            </td>
          </tr>

          <tr height="0">
            <td width="83" style="border:none"></td>
            <td width="100" style="border:none"></td>
            <td width="90" style="border:none"></td>
            <td width="100" style="border:none"></td>
            <td width="0" style="border:none"></td>
            <td width="90" style="border:none"></td>
          </tr>
        </table>
      </div>

      <p class="MsoNormal">
        <span lang="EN-US"><o:p>&nbsp;</o:p></span>
      </p>
    </div>
  
</template>

<style scoped>
.MsoTableGrid {
  margin: 0 auto;
}
</style>
